<div class="card pt-0 mb-5" >
    <div class="card-header">
        <h4>Mismatch Report</h4>
    </div>
    <div class="card-body">
        <!-- <div class="row hidden"> -->
            <div class="col-sm-4">
                <label class="form-label">Merchant Name <span aria-hidden="true" class="symbol required" style="color:red;">*</span> </label>
                <ng-select  (change)="onSelectMerchant($event)"
                  placeholder="Merchant Name">
                  <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.MerchantId">
                    {{merchant.merchant_name}} ({{merchant.MerchantId}})
                  </ng-option>
                </ng-select>
               
            </div>
            <!-- <div class="col-sm-2">
           
              <button class="btn btn-sm btn-primary mt-4"  type="submit" >Download </button>
              <div  *ngIf="loading" >  
                      <div class="spinner-border" role="status">
                        <span class="sr-only"></span>
                      </div>
              </div>
            </div> -->
           <!-- </div> -->
           <div *ngIf="showhtml">
                    <div class="row">
            <div class="col-lg-12">
                <h5 class="m-2">Comparision</h5>
                <ag-grid-angular style="width: 100%; height: 350px;" class="ag-theme-alpine" [columnDefs]="columnDefs"
                    [defaultColDef]="defaultColDef" [suppressRowClickSelection]="true" [groupSelectsChildren]="true"
                    [rowSelection]="'multiple'" [rowData]="rowData"></ag-grid-angular>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-lg-12 border">
                <h5 class="m-2">Status</h5>
                <div class="row border m-4"  *ngIf="!statusDto?.panNumber==null">
                    <h6 class="m-2">PAN</h6>

                    <div class="col-lg-5">
                        <label class="p-4">{{statusDto?.panNumber}}</label>
                    </div>
                    <div class="col-lg-5">
                        <label class="p-4">{{statusDto?.panStatus}}</label>
                    </div>
                </div>
                <div class="row border m-4" *ngIf="!statusDto?.gstNumber==null">
                    <h6 class="m-2">GST</h6>
                    <div class="col-lg-5">
                        <label class="p-4">{{statusDto?.gstNumber}}</label>
                    </div>
                    <div class="col-lg-5">
                        <label class="p-4">{{statusDto?.gstStatus}}</label>
                    </div>
                </div>
                <!-- *ngIf="directorDTOS" -->
                <div class="row border m-4" *ngIf="directorDTOS!=''">
                    <h6 class="m-2">Directorship</h6>
                    <div class="col-lg-12">

                        <table class="table" *ngFor="let directorDTOS of directorDTOS">
                            <thead class="table-warning"  >
                                <tr >
                                    <th>Name</th>
                                    <th></th>
                                    <th></th>
                                    <th>{{directorDTOS?.name}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>KID</td>
                                    <th>{{directorDTOS?.kid}}</th>
                                    <td>DIN</td>
                                    <th>{{directorDTOS?.din}}</th>
                                </tr>
                                <tr>
                                    <td>DIN PAN</td>
                                    <th>{{directorDTOS?.dinPan}}</th>
                                    <td>PAN Number</td>
                                    <th>{{directorDTOS?.panNumber}}</th>
                                </tr>
                                <tr>
                                    <td>Gender</td>
                                    <th>{{directorDTOS?.gender}}</th>
                                    <td>Email</td>
                                    <th>{{directorDTOS?.email}}</th>
                                </tr>
                                <tr>
                                    <td>DSC Registered</td>
                                    <th>{{directorDTOS?.isDscRegistered}}</th>
                                    <td>DSC Expiry Date</td>
                                    <th>{{directorDTOS?.dscExpiryDate}}</th>
                                </tr>
                                <tr>
                                    <td>Designation</td>
                                    <th>{{directorDTOS?.designation}}</th>
                                    <td>Date of Birth</td>
                                    <th>{{directorDTOS?.dateOfBirth}}</th>
                                </tr>
                                <tr>
                                    <td>Tenure Begin</td>
                                    <th>{{directorDTOS?.tenureBeginDate}}</th>
                                    <td>Tenure End</td>
                                    <th>{{directorDTOS?.tenureEndDate}}</th>
                                </tr>
                                <tr>
                                    <td>Father Name</td>
                                    <th>{{directorDTOS?.fatherName}}</th>
                                    <td>Status</td>
                                    <th>{{directorDTOS?.status}}</th>
                                </tr>
                                <tr>
                                    <td>Address</td>
                                    <td class="w-25">
                                        <p>{{directorDTOS?.address}}</p>
                                    </td>
                                    <td>City</td>
                                    <th>{{directorDTOS?.city}}</th>
                                </tr>
                                <tr>
                                    <td>State</td>
                                    <th>{{directorDTOS?.state}}</th>
                                    <td>PIN</td>
                                    <th>{{directorDTOS?.pin}}</th>
                                </tr>
                                <tr>
                                    <td>Date of Approval</td>
                                    <th>{{directorDTOS?.dinDateOfApproval}}</th>
                                    <!-- <th></th>
                                    <th></th>
                                    
                                    
                                    <th>{{directorDTOS.name}}</th> -->
                                    <!-- <th>{{directorDTOS?.dinDateOfApproval}}</th>  -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-lg-12 border">
                <h5 class="m-2">Risk Register</h5>
                <div class="row m-4">
                    <div class="col-lg-5">
                        <label class="p-4">Business Category : {{riskScoreDTO?.businessCategory}}</label>
                    </div>
                    <div class="col-lg-5">
                        <label class="p-4"> Business Sub Category : {{riskScoreDTO?.businessSubCategory}}</label>
                    </div>
                </div>
                <div class="row p-4">
                    <div class="col-lg-12">
                        <div class="progress progress-risk">
                            <div class="progress-bar bg-light-green w-19" role="progressbar" aria-valuenow="15"
                                aria-valuemin="0" aria-valuemax="100">
                                <span class="circle bg-light-green" *ngIf="riskScoreDTO?.riskScore==1">{{riskScoreDTO?.riskScore}}</span>
                            </div>
                            <div class="progress-bar bg-dark-green ml-1 w-19" role="progressbar" aria-valuenow="30"
                                aria-valuemin="0" aria-valuemax="100">
                                <span class="circle bg-dark-green"  *ngIf="riskScoreDTO?.riskScore==2">{{riskScoreDTO?.riskScore}}</span>
                            </div>
                            <div class="progress-bar bg-warning ml-1 w-19" role="progressbar" aria-valuenow="15"
                                aria-valuemin="0" aria-valuemax="100">
                                <span class="circle bg-warning"  *ngIf="riskScoreDTO?.riskScore==3">{{riskScoreDTO?.riskScore}}</span>
                            </div>
                            <div class="progress-bar bg-light-danger ml-1 w-19" role="progressbar" aria-valuenow="20"
                                aria-valuemin="0" aria-valuemax="100">
                                <span class="circle bg-light-danger"  *ngIf="riskScoreDTO?.riskScore==4">{{riskScoreDTO?.riskScore}}</span>
                            </div>
                            <div class="progress-bar bg-dark-danger ml-1 w-19" role="progressbar" aria-valuenow="20"
                                aria-valuemin="0" aria-valuemax="100">
                                <span class="circle bg-dark-danger"  *ngIf="riskScoreDTO?.riskScore==5">{{riskScoreDTO?.riskScore}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-lg-12 border">
                <h5 class="m-2">Alert Summary</h5>
                <div class="row border m-4">
                    <h6 class="m-2">Total Alert : {{alertSummaryDTO?.total}}</h6>
                    <ul class="round d-inline-flex">
                        <li class="light-voilet">Severe Risk {{alertSummaryDTO?.severity}}({{(alertSummaryDTO?.severity/alertSummaryDTO?.total)*100 |number : '1.2-2'}}%)</li>
                        <li class="dark-danger">High Risk {{alertSummaryDTO?.high}}({{(alertSummaryDTO?.high/alertSummaryDTO?.total)*100 |number : '1.2-2'}}%)</li>
                        <li class="light-danger">Medium Risk {{alertSummaryDTO?.medium}}({{(alertSummaryDTO?.medium/alertSummaryDTO?.total)*100 | number : '1.2-2'}}%)</li>
                        <li class="light-warning">Low Risk {{alertSummaryDTO?.low}}({{(alertSummaryDTO?.low/alertSummaryDTO?.total)*100 | number : '1.2-2'}}%)</li>
                    </ul>
                    <div class="progress progress-alert p-0">
                        <div class="progress-bar bg-dark-voilet-alert" role="progressbar" aria-valuenow="20"
                        aria-valuemin="0" aria-valuemax="50"  [ngStyle]="{'width.%':(alertSummaryDTO?.severity/alertSummaryDTO?.total)*100}"></div>
                        <div class="progress-bar bg-dark-danger-alert" role="progressbar" aria-valuenow="20"
                            aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width.%':(alertSummaryDTO?.high/alertSummaryDTO?.total)*100}"></div>
                        <div class="progress-bar bg-light-danger-alert" role="progressbar" aria-valuenow="15"
                            aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width.%':(alertSummaryDTO?.medium/alertSummaryDTO?.total)*100}"></div>
                        <div class="progress-bar bg-alert-warning" role="progressbar" aria-valuenow="15"
                            aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width.%':(alertSummaryDTO?.low/alertSummaryDTO?.total)*100}"></div>
                    </div>

                </div>
                <div class="row border m-4">
                    <h6 class="m-2">Alert Summary</h6>
                    <div class="col-lg-12"  >
                        <div class="row border-bottom m-4" *ngIf="alertListDTOFinal?.severitys!=''">
                            <div class="col-lg-3">Severe Risk</div>
                            <div class="col-lg-8">
                                <ul class="round d-inline-flex"  *ngFor="let alertListDTOs of alertListDTOFinal?.severitys"  >
                                    <li  *ngIf="alertListDTOs.severity=='severe' && alertListDTOs.exist" class="light-voilet">{{alertListDTOs?.alert}}</li>
                                   
                                </ul>
                            </div>
                        </div>
                        <div class="row border-bottom m-4" *ngIf="alertListDTOFinal?.high!=''">
                            <div class="col-lg-3">High Risk</div>
                            <div class="col-lg-8">
                                <ul class="round d-inline-flex"  *ngFor="let alertListDTOs of alertListDTOFinal?.high">
                                    <li  *ngIf="alertListDTOs.severity=='high' && alertListDTOs.exist "  class="dark-danger">{{alertListDTOs?.alert}}</li>
                                    
                                </ul>
                            </div>
                        </div>
                        <div class="row border-bottom m-4" *ngIf="alertListDTOFinal?.medium!=''">
                            <div class="col-lg-3">Medium Risk</div>
                            <div class="col-lg-8">
                                <ul class="round d-inline-flex" *ngFor="let alertListDTOs of alertListDTOFinal?.medium">
                                    <li   *ngIf="alertListDTOs.severity=='medium' && alertListDTOs.exist "class="light-danger">{{alertListDTOs?.alert}}</li>
                                   
                                </ul>
                            </div>
                        </div>
                        <div class="row border-bottom m-4" *ngIf="alertListDTOFinal?.low!=''">
                            <div class="col-lg-3">Low Risk</div>
                            <div class="col-lg-8">
                                <ul class="round d-inline-flex"  *ngFor="let alertListDTOs of alertListDTOFinal?.low">
                                 <li   *ngIf="alertListDTOs.severity=='low' && alertListDTOs.exist "class="light-warning">{{alertListDTOs?.alert}}</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>

    </div>
    
</div>
</div>
